import { IconDefinition } from "./types";

const plus: IconDefinition = {
  iconName: "plus",
  width: 448,
  height: 512,
  svgPathData:
    "M248 56l0-24-48 0 0 200-200 0 0 48 200 0 0 200 48 0 0-200 200 0 0-48-200 0 0-176z",
  iconType: "fill",
  fontAwesomeName: "plus",
  unicode: 0x2b,
};

export { plus };
